const SealQueryFields = [
    {
        name: '#',
        code: '_seq_',
        column: true,
        sortable: false,
        defaultFilter: false,
        width: 70
    },
    {
        name: '公章名称',
        code: 'name',
        column: true,
        defaultFilter: true,
        listFilter: true,
        width: 300
    },
    {
        name: '公章',
        code: 'imageUrl',
        column: true,
        sortable: false,
        align: 'left',
        width: 300
    },
    {
        name: '说明',
        align: 'left',
        code: 'description',
        defaultFilter: true,
        sortable: false,
        listFilter: true,
        column: true

    }
];
export default SealQueryFields;
